import { styled } from '@mui/system';
import { Button, CircularProgress } from '@mui/material';

// Styled Button Component
export const StyledButton = styled(Button)(({ theme, hasError }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: theme.spacing(1),
  padding: theme.spacing(2),
  width: 'fit-content',
  textWrap: 'nowrap',
  backgroundColor: 'black',
  border: hasError ? `1px solid ${theme.palette.error.main}` : 'none',

  // Button text styles
  fontSize: theme.typography.bodyRegular?.fontSize || '16px',
  fontWeight: theme.typography.bodyRegular?.fontWeight || 400,
  color: hasError ? theme.palette.error.main : theme.palette.text.secondary || 'blue',
  lineHeight: theme.typography.bodyRegular?.lineHeight || '24px',
  textTransform: 'none', // Prevent MUI Button default uppercase

  '&:hover': {
    backgroundColor: '#3A3A3C',
  },
  '& .MuiButton-startIcon': {
    margin: 0, // Reset default margins for icon wrapper
  },

  // Parent background variation
  '&.use-parent-background': {
    justifyContent: 'flex-start',
    padding: '0px',
    width: '100%',
    backgroundColor: 'transparent',
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
}));

export const StyledCircularProgress = styled(CircularProgress)(({ theme }) => ({
  color: theme.palette.text.secondary,
}));
